module.exports = __webpack_public_path__ + "img/1.2.659abd6f.png";